import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from 'sweetalert2';

function EditSchool() {
    const { t } = useTranslation();
    const { user } = useAuth();

    // State Tanımlamaları
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    // Okul verilerini tutan state
    const [schoolData, setSchoolData] = useState({
        id: "",
        schoolName: "",
        schoolLogo: "",
        isDeleted: false,
        studentLimit: 0,
        createdAt: "",
        expiryDate: "",
        isActive: true
    });

    // Form input değişikliklerini yakalama
    const handleInputChange = (e) => {
        setSchoolData({ ...schoolData, [e.target.name]: e.target.value });
    };

    // Resim Yükleme İşlemi
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setIsUploading(true);
        const formData = new FormData();
        formData.append('FormFile', file);

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + user.token
            };
            const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';

            const res = await axios.post(url, formData, {
                params: { mediaType: "photo" },
                headers: headerss
            });

            if (res.status === 200 && res.data['success']) {
                // Yeni yüklenen resim yolunu state'e kaydet (Artık sunucuya bu gidecek)
                setSchoolData({ ...schoolData, schoolLogo: res.data['data']['path'] });
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Resim sunucuya yüklendi.',
                    showConfirmButton: false,
                    timer: 2000
                });
            } else {
                setMsg(res.data['message'] || "Resim yüklenemedi.");
            }
        } catch (err) {
            setMsg("Resim yükleme sırasında hata oluştu: " + err.message);
        } finally {
            setIsUploading(false);
        }
    };

    // Okul Güncelleme İşlemi
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMsg("");

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/manager/EditSchool/UpdateSchool";

            const res = await axios.post(url, {
                id: schoolData.id,
                isDeleted: schoolData.isDeleted,
                schoolLogo: schoolData.schoolLogo, // Artık yeni veya mevcut logo doğru gidiyor
                studentLimit: schoolData.studentLimit,
                createdAt: schoolData.createdAt,
                expiryDate: schoolData.expiryDate,
                isActive: schoolData.isActive,
                schoolName: schoolData.schoolName,
            }, { headers: headerss });

            if (res.status === 200 && res.data['success']) {
                Swal.fire({
                    title: "Güncellendi!",
                    text: "Okul bilgileri başarıyla kaydedildi.",
                    icon: "success",
                    timer: 2500,
                    showConfirmButton: false
                });
                // Sayfayı reload etmek yerine state zaten güncel kaldı.
            } else {
                setMsg(res.data['message']);
                Swal.fire("Hata", res.data['message'], "error");
            }
        } catch (err) {
            Swal.fire("Hata", "Beklenmedik bir hata oluştu.", "error");
            setMsg(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    // İlk Yüklemede Verileri Çekme
    useEffect(() => {
        const fetchSchoolData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                };
                let url = "https://api.heryerdeingilizce.com/api/manager/EditSchool/GetSchoolDetail";

                const res = await axios.get(url, { headers: headerss });

                if (res.status === 200 && res.data['success']) {
                    setSchoolData(res.data['data']);
                } else {
                    setMsg(res.data['message']);
                }
            } catch (err) {
                setMsg("Veriler çekilirken bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchSchoolData();
    }, [user.token]);

    return (
        <div className="container-fluid py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8">

                    {msg && <div className="alert alert-warning text-center shadow-sm">{msg}</div>}

                    <div className="card shadow border-0 rounded-3">
                        <div className="card-header bg-primary text-white text-center py-3 border-0 rounded-top">
                            <h3 className="mb-0 fw-bold">{t("editSchool")}</h3>
                        </div>

                        <div className="card-body p-4 p-md-5">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Yükleniyor...</span>
                                    </div>
                                    <p className="mt-3 text-muted fw-semibold">Okul Bilgileri Yükleniyor...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>

                                    <div className="mb-4">
                                        <label htmlFor="schoolName" className="form-label fw-bold text-secondary">
                                            {t("schoolName")}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg bg-light"
                                            name="schoolName"
                                            id="schoolName"
                                            value={schoolData.schoolName || ""}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-5">
                                        <label htmlFor="schoolLogo" className="form-label fw-bold text-secondary">Okul Logosu (Opsiyonel)</label>
                                        <input
                                            id="schoolLogo"
                                            className="form-control form-control-lg bg-light"
                                            accept="image/png, image/jpeg, image/jpg"
                                            type="file"
                                            name="file"
                                            onChange={handleFileUpload}
                                            disabled={isUploading}
                                        />
                                        {isUploading && (
                                            <div className="form-text text-primary mt-2">
                                                <i className="spinner-border spinner-border-sm me-1"></i> Resim yükleniyor...
                                            </div>
                                        )}
                                        {schoolData.schoolLogo && !isUploading && (
                                            <div className="form-text text-success mt-2">
                                                <i className="bi bi-check-circle me-1"></i> Yeni logo seçildi/mevcut.
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-grid gap-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-lg py-3 fw-bold shadow-sm"
                                            disabled={isSubmitting || isUploading}
                                        >
                                            {isSubmitting ? (
                                                <span><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Güncelleniyor...</span>
                                            ) : (
                                                <> <i className="bi bi-save me-2"></i> {t("update")} </>
                                            )}
                                        </button>
                                    </div>

                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditSchool;